import React, { useState } from 'react';
import { Alert, Box, Collapse, IconButton } from '@mui/material';
import CampaignIcon from '@mui/icons-material/Campaign';
import CloseIcon from '@mui/icons-material/Close';
import { useSiteAlert } from '@/contexts/SiteAlertContext';

const TCCDeadlineBanner = () => {
  const [open, setOpen] = useState(true);
  const { message, isActive } = useSiteAlert();
  // console.log(isActive, message)
  if (!isActive) {
    return null;
  }

  return (
    <Collapse in={open}>
      <Alert
        icon={<CampaignIcon />}
        severity="info"
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => setOpen(false)}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
        sx={{ borderRadius: 0 }}
      >
        <Box
          sx={{
            '& p': { margin: 0 },
          }}
          dangerouslySetInnerHTML={{ __html: message.replace(/\\"/g, '"') }}
        />
      </Alert>
    </Collapse>
  );
};

export default TCCDeadlineBanner;